var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import '../buttons/tool-icon-button.js';
import { WithDisposable } from '@blocksuite/lit';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ReleaseFromGroupButtonIcon } from '../../../../_common/icons/index.js';
let EdgelessReleaseFromGroupButton = class EdgelessReleaseFromGroupButton extends WithDisposable(LitElement) {
    render() {
        return html `<edgeless-tool-icon-button
      .iconContainerPadding=${2}
      @click=${() => {
            this.surface.group.releaseFromGroup(this.surface.edgeless.selectionManager.firstElement);
        }}
      .tooltip=${'Release From Group'}
      .tipPosition=${'bottom'}
    >
      ${ReleaseFromGroupButtonIcon}
    </edgeless-tool-icon-button> `;
    }
};
__decorate([
    property({ attribute: false })
], EdgelessReleaseFromGroupButton.prototype, "surface", void 0);
EdgelessReleaseFromGroupButton = __decorate([
    customElement('edgeless-release-from-group-button')
], EdgelessReleaseFromGroupButton);
export { EdgelessReleaseFromGroupButton };
//# sourceMappingURL=release-from-group-button.js.map